// extracted by mini-css-extract-plugin
export default {"container":"login-choice_container__8cc8f"};